<template>
  <div class="footer fontNB">
    <!-- todo: remove yellow footer -->
    <div class="sendEmail" v-if="false">
      <div class="content">
        <el-row style="width: 100%;">
          <!-- @click="$store.commit('changeRegisterShow',true);" -->
          <el-col class="emailLine" :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <p><span style="cursor: pointer;" @click="$refs.tagInput.$refs.input.focus();">{{ $t('footbar.signup') }}&nbsp;</span>{{
                $t('footbar.footer')
              }}</p>
          </el-col>
          <el-col class="emailLine" :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-form labelPosition="top" ref="footerForm" :model="footerForm" :rules="rules" @submit.native.prevent>
              <el-form-item prop="email">
                <el-input
                  ref="tagInput"
                  :placeholder="$t('footbar.input')"
                  v-model="footerForm.email"
                  @change="newsLetter()">
                  <i slot="suffix" class="el-input__icon el-icon-s-promotion"
                     style="font-size: 18px;color: #fff;cursor:pointer;" @click="newsLetter()"></i>
                </el-input>
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
      </div>
    </div>

    <div class="contactBox">
      <!-- <div class="contact">
        <el-row :gutter="80">
          <el-col :span="7">
            <div class="contactItem">
              <dl>
                <dt>關於我們</dt>
                <dt>隱私條款</dt>
                <dt>服務條款</dt>
              </dl>
            </div>
          </el-col>
          <el-col :span="7">
            <div class="contactItem">
              <dl>
                <dt>關於我們</dt>
                <dt>隱私條款</dt>
              </dl>
            </div>
          </el-col>
          <el-col :span="10">
            <div class="contactItem">
              <dl>
                <dt>關於我們</dt>
                <dt>隱私條款</dt>
              </dl>
            </div>
          </el-col>
        </el-row>
      </div> -->
      <div class="contact">
        <div class="contactItem">
          <dl>
            <dt @click="$router.push({path: '/About'})">{{ $t('footbar.about') }}</dt>
            <dt @click="$router.push({path: '/PrivacyPolicy'})">{{ $t('footbar.privacy') }}</dt>
            <dt @click="$router.push({path: '/T&C'})">{{ $t('footbar.terms') }}</dt>
          </dl>
        </div>
        <div class="contactItem">
          <dl>
            <dt @click="$router.push({path: '/DeliveryService'})">{{ $t('footbar.shipping') }}</dt>
            <dt>
              <a href="/uploads/download/Wenno.apk" target="_blank" style="color: inherit; text-decoration: none;">
                {{ $t('top.downloadApp') }}
              </a>
            </dt>
            <dt @click="$router.push({path: '/ContactUs'})">{{ $t('footbar.contact') }}</dt>
          </dl>
        </div>
        <div class="contactItem">
          <dl>
            <dt>{{ $t('footbar.subscribe') }}</dt>
            <dt>
              <!-- todo: 電子訂閲 -->
              <el-form labelPosition="top" ref="footerForm" :model="footerForm" :rules="rules"
                       @submit.native.prevent>
                <el-input :placeholder="$t('dialog.email')" v-model="footerForm.email">
                  <template slot="append">
                    <span class="subscribe" @click="newsLetter()">{{ $t('footbar.btnSubscribe') }}</span>
                  </template>
                </el-input>
              </el-form>
            </dt>
          </dl>
        </div>
      </div>
    </div>
    <!-- 手機 -->
    <!-- <div class="contactBoxMobile" v-else>
      <el-collapse v-model="activeNames">
        <el-collapse-item title="关于我们" name="1">
          <ul>
            <li>shop</li>
            <li>Category</li>
            <li>Animals</li>
            <li>Product list</li>
          </ul>
        </el-collapse-item>
        <el-collapse-item title="支持" name="2">
          <ul>
            <li>shop</li>
            <li>Category</li>
            <li>Animals</li>
            <li>Product list</li>
          </ul>
        </el-collapse-item>
        <el-collapse-item title="探索发现" name="3">
          <ul>
            <li>shop</li>
            <li>Category</li>
            <li>Animals</li>
            <li>Product list</li>
          </ul>
        </el-collapse-item>
        <el-collapse-item title="更多服务" name="4">
          <ul>
            <li>shop</li>
            <li>Category</li>
            <li>Animals</li>
            <li>Product list</li>
          </ul>
        </el-collapse-item>
      </el-collapse>
    </div> -->

    <div class="copyright">
      <div class="content">
        <div class="copyLine">&copy; COPYRIGHT Wenno 2022
          {{ $t('footer.info') }}
          <span @click="$router.push({path: '/T&C'})">{{ $t('footer.tc') }}</span>
        </div>
        <div class="copyLine btns">
          <div>
            <div class="foot_icon" @click="goWenno('facebook')">
              <i class="facebook"></i>
            </div>
            <div class="foot_icon" @click="goWenno('instagram')">
              <i class="ins"></i>
            </div>
            <div class="foot_icon" @click="goWenno('wechat')">
              <i class="wechat"></i>
            </div>
          </div>
          <div>
            <div class="foot_icon">
              <i class="fimg1"></i>
            </div>
            <div class="foot_icon">
              <i class="fimg2"></i>
            </div>
            <div class="foot_icon">
              <i class="fimg3"></i>
            </div>
            <div class="foot_icon">
              <i class="fimg4"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    var validateEmail = (rule, value, callback) => {
      var myreg = /^([a-zA-Z0-9]+[_|\_|\.\-]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/;
      if (value === '') {
        callback(new Error(this.$t('dialog.pemail')));
      } else if (!myreg.test(value)) {
        callback(new Error(this.$t('dialog.pvemail')));
      } else {
        callback();
      }
    };
    return {
      footerForm: {
        email: '',
      },
      rules: {
        email: [
          { validator: validateEmail, trigger: 'blur' },
        ],
      },
      screenWidth: document.body.clientWidth,
      activeNames: [],
    };
  },
  mounted () {
    const that = this;
    window.onresize = () => {
      that.screenWidth = document.body.clientWidth;
      // console.log(that.screenWidth,">>>>>>>>>>>>>>>>>>>>>>");
    };
  },
  methods: {
    async newsLetter () {
      const valid = await this.$refs.footerForm.validate();
      if (valid) {
        if (this.$store.state.token &&
          String(this.$store.state.user.email).toLowerCase() === String(this.footerForm.emai).toLowerCase()) {
          const res = await this.$axios({
            method: 'post',
            url: '/api/news_letter/setting',
            headers: {
              'Authorization': this.$localStorage.token_type + this.$localStorage.token,
            },
            data: {
              is_newsletter: 1,
            },
          });

          if (res.status_code === 201) {
            this.$message({
              message: this.$t('btnText.setSuccess'),
              type: 'success',
              duration: 1800,
              offset: 200,
            });
            this.$store.commit('setNewsletter', 1);
            this.ga.event('footer', 'click', 'newsletter');
            fbq('track', 'openNewsletter', { email: this.$store.state.user.email });
          }

          return;
        }
        await this.setNewsletter();
      }
    },
    async setNewsletter () {
      await this.$axios({
        method: 'post',
        url: '/api/news_letter',
        data: this.footerForm,
      }).then(res => {
        console.log(res);
        if (res.status_code === 201) {
          this.$message({
            message: this.$t('btnText.regSuccess'),
            type: 'success',
            duration: 1800,
            offset: 200,
          });
          this.ga.event('footer', 'click', 'newsletter');
          fbq('track', 'openNewsletter', { email: this.footerForm.email });
          this.footerForm.email = '';
          this.$refs.footerForm.resetFields();
        }
      }).catch(error => {
        console.log(error);
        this.$message({
          message: error.response.data.message, // this.$t('btnText.emailExist'),
          type: 'error',
          duration: 1800,
          offset: 200,
        });
        this.$refs.footerForm.resetFields();
      });
    },
    goWenno (type) {
      if (type === 'facebook') {
        this.ga.event('footer', 'Link', 'facePage');
        fbq('track', 'viewContent', { content_name: 'facebook' });
        window.open(this.$t('socialMediaLinks.facebook'));
      } else if (type === 'instagram') {
        this.ga.event('footer', 'Link', 'insPage');
        fbq('track', 'viewContent', { content_name: 'ins' });
        window.open(this.$t('socialMediaLinks.instagram'));
      } else if (type === 'wechat') {
        this.ga.event('footer', 'Link', 'wechat');
        fbq('track', 'viewContent', { content_name: 'wechat' });
        window.open(this.$t('socialMediaLinks.wechat'));
      }
    },
  },
  watch: {
    screenWidth (val) {
      this.screenWidth = val;
    },
  },
};
</script>
<style scoped>
/deep/ .el-collapse {
  border : 0;
}

/deep/ .el-collapse-item__header {
  background-color : inherit;
  color            : white;
  padding-left     : 20px;
  font-size        : 18px;
}

/deep/ .el-collapse-item__wrap {
  background-color : inherit;
}

/deep/ .el-collapse-item__content {
  padding : 0;
  color   : white;
}

/deep/ .el-collapse {
  background-color : inherit;
}

.contactBoxMobile ul li {
  font-size  : 14px;
  padding    : 10px 20px;
  border-top : 1px solid white;
}

.contactBox, .contactBoxMobile {
  background-color : #1B1B1B;
  padding          : 0 0 20px 0;
  color            : white;
}

.contact {
  max-width       : 1200px;
  margin          : auto;
  display         : flex;
  justify-content : space-around;
  flex-wrap       : wrap;
}

.contact .contactItem {
  font-size     : 21px;
  margin-bottom : 10px;
}

.contactItem dl {
  height          : 100%;
  display         : flex;
  flex-direction  : column;
  justify-content : space-around;
}

dl dt {
  cursor : pointer;
}

.contactItem /deep/ .el-input-group__append {
  background-color : #E2AF00;
  border-color     : #F1BC06;
  color            : #4E472C;
  cursor           : pointer;
}

.contactItem /deep/ .el-input__inner::placeholder {
  color : rgb(148, 145, 145);
}

.sendEmail /deep/ .el-input__inner {
  background-color : #E2AF00;
  border-color     : #F1BC06;
}

/deep/ .el-input__inner::placeholder {
  color : #fff;
}

.footer {
  /* width: 100%; */
  height : auto;
}

.footer > div {
  /* width: 100%; */
}

.sendEmail {
  background-color : #FFC80B;
  padding-bottom   : 10px;
}

.copyright {
  border-top       : 1px solid #FFC80B;
  background-color : #fff;
  padding          : 8px 0;
}

.emailLine {
  height      : 40px;
  line-height : 40px;
  margin      : 20px 0;
}

.emailLine > p {
  margin-top  : 10px;
  line-height : 20px;
  font-size   : 14px;
  color       : #fff;
}

.emailLine > p > span {
  color : #FD403E;
}

.copyLine {
  flex      : auto;
  width     : 50%;
  font-size : 12px;
  color     : #4A4A4A;
}

.copyLine span {
  color           : #FFC80B;
  text-decoration : underline;
  cursor          : pointer;
}

.btns {
  display         : flex;
  align-items     : center;
  justify-content : space-around;
}

.btns > div:first-child {
  width      : 40%;
  text-align : right;
}

.btns > div:last-child {
  width      : 60%;
  text-align : center;
}

.foot_icon {
  display       : inline-block;
  line-height   : 1;
  white-space   : nowrap;
  cursor        : pointer;
  text-align    : center;
  outline       : 0;
  margin        : 0;
  margin-left   : 10px;
  font-size     : 12px;
  color         : #FFF;
  border-radius : 50%;
}

.facebook, .ins, .wechat {
  width            : 24px;
  height           : 24px;
  display          : inline-block;
  background-size  : 100%;
  border-radius    : 100%;
  background-color : #7a7a7a;
}

.facebook:hover,
.facebook:focus,
.ins:hover,
.ins:focus,
.wechat:hover,
.wechat:focus {
  background-color : #FFC80B;
}

.facebook {
  background-image : url(../assets/img/footer/facebook.png);
}

.ins {
  background-image : url(../assets/img/footer/instagram.png);
}

.wechat {
  background-image : url(../assets/img/footer/wechat.png);
}

.fimg1 {
  width           : 32px;
  height          : 20px;
  display         : inline-block;
  background      : url(../assets/img/f1.png) 50% 50% no-repeat;
  background-size : 32px 20px;
}

.fimg1:hover {
  background      : url(../assets/img/f11.png) 50% 50% no-repeat;
  background-size : 32px 20px;
}

.fimg2 {
  width           : 32px;
  height          : 20px;
  display         : inline-block;
  background      : url(../assets/img/f2.png) 50% 50% no-repeat;
  background-size : 32px 20px;
}

.fimg2:hover {
  background      : url(../assets/img/f22.png) 50% 50% no-repeat;
  background-size : 32px 20px;
}

.fimg3 {
  width           : 32px;
  height          : 20px;
  display         : inline-block;
  background      : url(../assets/img/f3.png) 50% 50% no-repeat;
  background-size : 32px 20px;
}

.fimg3:hover {
  background      : url(../assets/img/f33.png) 50% 50% no-repeat;
  background-size : 32px 20px;
}

.fimg4 {
  width           : 32px;
  height          : 20px;
  display         : inline-block;
  background      : url(../assets/img/f4.png) 50% 50% no-repeat;
  background-size : 32px 20px;
}

.fimg4:hover {
  background      : url(../assets/img/f44.png) 50% 50% no-repeat;
  background-size : 32px 20px;
}

/*手机*/
@media screen and (max-width : 768px) {
  .contact .contactItem {
    font-size    : 18px;
    width        : 35%;
    padding-left : 40px;
  }

  .content {
    width           : 100%;
    margin          : auto;
    display         : flex;
    align-items     : center;
    justify-content : flex-start;
    flex-direction  : column;
  }

  .copyLine {
    width      : 100%;
    text-align : center;
  }

  .btns {
    width : 100%;
  }

  .btns > div:first-child {
    width      : 40%;
    text-align : center;
  }

  .emailLine {
    width  : 90%;
    margin : 10px 5%;
  }

  .el-row .emailLine:first-child {
    line-height : 30px;
    min-height  : 30px;
    height      : auto;
  }

  .el-row .emailLine:last-child {
    margin-top : 0;
  }
}

/*平板*/
@media screen and (min-width : 768px) and (max-width : 992px) {
  .contact .contactItem {
    font-size    : 20px;
    width        : 45%;
    padding-left : 40px;
    text-align   : center;
  }

  .content {
    width           : 80%;
    margin          : auto;
    display         : flex;
    align-items     : center;
    justify-content : flex-start;
  }

  .emailLine {
    margin : 5px auto;
  }
}

/*中等屏幕*/
@media screen and (min-width : 992px) and (max-width : 1200px) {
  .content {
    width           : 90%;
    margin          : auto;
    display         : flex;
    align-items     : center;
    justify-content : flex-start;
  }
}

/*大屏幕*/
@media screen and (min-width : 1200px) {
  .content {
    width           : 90%;
    max-width       : 1200px;
    margin          : auto;
    display         : flex;
    align-items     : center;
    justify-content : flex-start;
  }
}
</style>



// WEBPACK FOOTER //
// src/common/Footer.vue